import { render, staticRenderFns } from "./SideTagsIM.vue?vue&type=template&id=04db63e4&scoped=true&"
import script from "./SideTagsIM.vue?vue&type=script&lang=js&"
export * from "./SideTagsIM.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsIM.vue?vue&type=style&index=0&id=04db63e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db63e4",
  null
  
)

export default component.exports